var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('Delete User'))+" ")]),_c('v-btn',{staticClass:"error mt-3",on:{"click":_vm.removeUser}},[_vm._v(" "+_vm._s(_vm.$t('Delete User'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }